import axios from 'axios'

const api = axios.create({
    // baseURL: 'http://localhost:21087'
    // baseURL: 'http://192.168.0.41:3000'
    baseURL: 'http://apiplanexcon.com.br',
  });
  
  export default api;